// extracted by mini-css-extract-plugin
export default {"container":"Fo-z","ratingLayout":"Go-z","ratingLabel":"Ho-z","nonInteractiveRatingLabel":"Io-z"};